module.exports = __webpack_public_path__ + "static/media/Full Stack Developer Resume.01e21865.pdf";